import { namespaceActions } from 'modules/app-core/redux-utils'
import { NAME } from './constants'

const LOAD_LOCATIONS = 'LOAD_LOCATIONS'
const RESET_LOCATIONS = 'RESET_LOCATIONS'
const RESTORE_SELECTION = 'RESTORE_SELECTION'
const CLEAR_PENDING_RESTORATION = 'CLEAR_PENDING_RESTORATION'

export default namespaceActions(NAME)([
  LOAD_LOCATIONS,
  RESET_LOCATIONS,
  RESTORE_SELECTION,
  CLEAR_PENDING_RESTORATION,
])
